<template>
  <div class="lottery-wrapper" v-if="isshow">
    <div class="join_lottery">
      <div class="lottery_box">
        <p class="export_out"><span class="goback" @click="goback"><img src="./img/back.png"></span>中奖名单<span class="export_btn" @click="export_list">导出中奖名单</span></p>
        <div class="list_detail" v-for='(i, index) in drawPrizes' :key=index>
          <p class="prize_level">奖品：{{i.name}} x {{i.num}}名</p>
          <div class="winner_info" v-for="(item, idx) in i.winningRecords" :key=idx>
            <p class="winner_name"><span class="name">{{item.name}}</span>{{item.phone}}</p>
            <p class="winner_address" v-if="item.address">收货地址：{{item.address.province}}{{item.address.city}}{{item.address.district}}{{item.address.locationDetail}}</p>
            <p class="winner_address" v-else-if="i.prizeType.indexOf(4) != -1">收货地址：<span>未提交</span></p>
            <p class="prize_status" v-if="i.prizeType.indexOf(1) != -1 && i.prizeType.indexOf(2) != -1 && i.prizeType.indexOf(3) != -1">
              发送情况：<span class="prize_status" v-if="item.sendGoodsList">商品开通成功</span><span class="prize_status" v-else>商品等待开通</span>、
              <span class="prize_status" v-if="item.sendCargoList">货品开通成功</span><span class="prize_status" v-else>货品等待开通</span>、
              <span class="prize_status" v-if="item.sendCouponList">优惠券已发放</span><span class="prize_status" v-else>优惠券{{i.couponIdList}}等待发放</span>
            </p>
            <p class="prize_status" v-else-if="i.prizeType.indexOf(1) != -1 && i.prizeType.indexOf(2) != -1">
              发送情况：<span class="prize_status" v-if="item.sendGoodsList">商品开通成功</span><span class="prize_status" v-else>商品等待开通</span>、
              <span class="prize_status" v-if="item.sendCargoList">货品开通成功</span><span class="prize_status" v-else>货品等待开通</span>
            </p>
            <p class="prize_status" v-else-if="i.prizeType.indexOf(1) != -1 && i.prizeType.indexOf(3) != -1">
              发送情况：<span class="prize_status" v-if="item.sendGoodsList">商品开通成功</span><span class="prize_status" v-else>商品等待开通</span>、
              <span class="prize_status" v-if="item.sendCouponList">优惠券已发放</span><span class="prize_status" v-else>优惠券{{i.couponIdList}}等待发放</span>
            </p>
            <p class="prize_status" v-else-if="i.prizeType.indexOf(2) != -1 && i.prizeType.indexOf(3) != -1">
              发送情况：<span class="prize_status" v-if="item.sendCargoList">货品开通成功</span><span class="prize_status" v-else>货品等待开通</span>、
              <span class="prize_status" v-if="item.sendCouponList">优惠券已发放</span><span class="prize_status" v-else>优惠券{{i.couponIdList}}等待发放</span>
            </p>
            <p class="prize_status" v-else-if="i.prizeType.indexOf(1) != -1">
              发送情况：<span class="prize_status" v-if="item.sendGoodsList">商品开通成功</span><span class="prize_status" v-else>商品等待开通</span>
            </p>
            <p class="prize_status" v-else-if="i.prizeType.indexOf(2) != -1">
              发送情况：<span class="prize_status" v-if="item.sendCargoList">货品开通成功</span><span class="prize_status" v-else>货品等待开通</span>
            </p>
            <p class="prize_status" v-else-if="i.prizeType.indexOf(3) != -1">
              发送情况：<span class="prize_status" v-if="item.sendCouponList">优惠券已发放</span><span class="prize_status" v-else>优惠券{{i.couponIdList}}等待发放</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {global} from '../../common/api/api.config'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      isshow: true,
      drawPrizes: ''
    }
  },
  mounted () {
    this.namelist()
  },
  methods: {
    namelist () {
      this.$api.GETWINNINGPRIZERECORDSDETAIL({
        id: Number(this.$route.query.id)
      }).then(res => {
        if (res.code === 0) {
          this.drawPrizes = res.data.drawPrizes
          console.log(this.drawPrizes)
        }
      }, err => {
        console.log(err)
      })
    },
    // 导出中奖名单
    export_list () {
      let SERVER_BASE_URL
      if (window.location.host === 'live.eoffcn.com') {
        SERVER_BASE_URL = global.mall_online_url
      } else {
        SERVER_BASE_URL = global.mall_test_url
      }
      let that = this
      sso.ready().then(function (user) { // eslint-disable-line
        axios({
          url: SERVER_BASE_URL + '/drawTeacher/exportDrawResult',
          method: 'post',
          headers: user.getHeader(),
          responseType: 'arraybuffer',
          data: {
            ids: [Number(that.$route.query.id)]
          }
        }).then((res) => {
          Toast({
            message: '导出成功',
            className: 'offcn-toast'
          })
          // let blob = new Blob([res])
          // let href = window.URL.createObjectURL(blob)
          // let link = document.createElement('a') // 创建a标签
          // link.download = '中奖学员名单' + parseInt(new Date().getTime() / 1000) + '.xlsx'
          // link.style.display = 'none'
          // link.href = href
          // document.body.appendChild(link)
          // link.click() // 执行下载
          // window.URL.revokeObjectURL(href)
          // document.body.removeChild(link) // 释放标签
          if (!webAccessor) return // eslint-disable-line
          webAccessor.save(that.ab2str(res.data)) // eslint-disable-line
        })
      })
    },
    ab2str (buf) {
      return String.fromCharCode.apply(null, new Uint8Array(buf))
    },
    goback () {
      window.history.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.lottery-wrapper {
  p {
    margin: 0;
  }
  .join_lottery {
    background: #ffffff;
    padding-bottom: 20px;
    .export_out {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .goback {
        cursor: pointer;
      }
    }
    .lottery_box {
      padding: 10px 24px 0;
    }
    .export_btn {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      color: #ffffff;
      background: #fe895f;
      border-radius: 4px;
      cursor: pointer;
    }
    .list_detail {
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      margin-top: 10px;
      .prize_level {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        background: #fafafa;
        padding: 0 20px;
      }
      .winner_info {
        font-size: 14px;
        padding: 10px 20px;
        border-bottom: 1px solid #e6e6e6;
        .winner_name {
          color: #0d152d;
          .name {
            font-size: 16px;
            font-weight: bold;
            margin-right: 10px;
          }
        }
        .winner_address, .prize_status {
          margin-top: 6px;
        }
      }
      .winner_info:last-child {
        border: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-lottery/winlist.vue